import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

const ProfileRoleContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex: 0 100%;
  height: ${SIZES['48']};
  align-items: center;
  border-top: 1px solid ${COLORS.fupaSecondary};
`;

const ProfileRoleStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ProfileRoleStats = ({statisticValues, statisticKeys}) => {
  const getStats = Object.keys(statisticKeys).map(key => (
    <ProfileRoleStat key={key}>
      <Typography variant='body1'>{statisticValues[key]}</Typography>
      <Typography variant='caption1'>{statisticKeys[key]}</Typography>
    </ProfileRoleStat>
  ));

  return <ProfileRoleContainer>{getStats}</ProfileRoleContainer>;
};

export default ProfileRoleStats;
